import SectionHead from "./SectionHead";
import { liveUpdates } from "@/mocks/homeData";

export default function LiveTimeline() {
  return (
    <section
      id="live"
      className="border-y border-background-200 bg-background-100 px-4 py-12 md:px-10 md:py-16"
    >
      <SectionHead
        index="04"
        title="实时动态"
        en="Live Feed"
        desc="站内每一次新增、修订与换稿都会留下记录。不必刷新，往下翻就能看到最新的几条。"
      />

      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-3">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 font-label text-xs text-primary-700">
            <span className="pulse-dot h-2 w-2 rounded-full bg-primary-500" />
            同步中
          </div>
          <p className="mt-4 text-sm leading-loose text-foreground-600">
            页面上的时间线按倒序排列，最近一次更新会出现在最上方，方便你对上自己的浏览进度。
          </p>
        </div>

        <div className="lg:col-span-9">
          <div className="relative pl-6 md:pl-8">
            <span className="absolute left-[3px] top-2 bottom-2 w-px bg-background-300 md:left-[5px]" />
            {liveUpdates.map((item) => (
              <div key={`${item.time}-${item.title}`} className="relative pb-8 last:pb-0">
                <span className="pulse-dot absolute -left-6 top-1.5 h-2.5 w-2.5 rounded-full bg-primary-500 md:-left-8" />
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-heading text-sm font-black text-foreground-950">{item.time}</span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[10px] text-secondary-900">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}